import React from "react"
import Layout from "../components/includes/layout"
import { graphql } from "gatsby"
import { SliceZone} from "@prismicio/react"
import { components } from "../components/slices"
import Seo from "../components/includes/seo"

export const pageQuery = graphql`
query PageQuery($id: String) {
    prismicPage(id: {eq: $id}) {
        _previewable
        data {
          description {
            text
          }
          meta_image {
            url
            alt
            gatsbyImageData(layout: CONSTRAINED, placeholder: NONE)
          }
          title {
            text
          }
          hide
          cta_footer
          body {
          ... on PrismicPageDataBodyUpcomingWebinars {
            id
            slice_type
            primary {
              background
              spacing
            }
          }
          ... on PrismicPageDataBodyAllWebinars {
            id
            slice_type
            primary {
              background
              section_title {
                richText
                text
              }
              spacing
            }
          }
          ... on PrismicPageDataBodyAllEvents {
            id
            slice_type
            primary {
              background
              section_title {
                richText
                text
              }
              spacing
            }
          }
          ... on PrismicPageDataBodyUpcomingEvents {
            id
            slice_type
            primary {
              background
              spacing
            }
          }
            ... on PrismicPageDataBodyVideoFeature {
              id
              slice_type
              primary {
                background
                label
                section_content {
                  richText
                }
                section_title {
                  richText
                  text
                }
                spacing
                youtube_id
                youtube_image {
                  alt
                  gatsbyImageData
                }
              }
            }
            ... on PrismicPageDataBodyHeroBannerForm {
              id
              slice_type
              primary {
                article_title {
                  richText
                  text
                }
                button_color
                button_label
                button_link {
                  url
                }
                content {
                  richText
                }
                custom_html
                form_id
                label
                theme
                form_content {
                  richText
                }
                form_title {
                  richText
                  text
                }
              }
            }
            ... on PrismicPageDataBodySideForm {
              id
              slice_type
              primary {
                background
                form_content {
                  richText
                }
                form_id
                form_title {
                  richText
                }
                html
                layout
                spacing
              }
            }
            ... on PrismicPageDataBodyVideoGrid {
              id
              slice_type
              items {
                caption
                image {
                  gatsbyImageData(placeholder: NONE)
                  alt
                }
                video_id
              }
              primary {
                background
                section_content {
                  richText
                }
                section_title {
                  richText
                  text
                }
                spacing
              }
            }
            ... on PrismicPageDataBodyResultsPage {
              id
              items {
                data_content {
                  text
                }
                data_point {
                  text
                }
                theme
              }
              primary {
                background
                section_content {
                  richText
                }
                section_title {
                  richText
                }
                spacing
              }
              slice_type
            }
            ... on PrismicPageDataBodySideBySideImage {
              id
              slice_type
              items {
                bullet_background
                bullet_content {
                  richText
                }
                icon {
                  url
                }
                theme
              }
              primary {
                background
                content {
                  richText
                }
                cta_color
                cta_label
                cta_link {
                  url
                }
                image_alignment
                custom_code
                image {
                  gatsbyImageData(placeholder: NONE)
                  alt
                }
                label
                layout
                theme
                title {
                  text
                  richText
                }
              }
            }
            ... on PrismicPageDataBodyMultilogoquote {
              id
              items {
                author
                author_meta
                brand_logo {
                  gatsbyImageData(placeholder: NONE)
                  alt
                }
                quote {
                  richText
                }
              }
              primary {
                text_color
                box_background
                background
                spacing
              }
              slice_type
            }
            ... on PrismicPageDataBodyLottie2Column {
              id
              slice_type
              primary {
                background
                custom_html
                lottie_json_1
                lottie_json_2
                spacing
                section_title{
                  richText
                }
                section_content{
                  richText
                }
              }
            }
            ... on PrismicPageDataBodyMarqueeLogo {
              id
              slice_type
              items {
                logo {
                  gatsbyImageData
                  alt
                }
              }
              primary {
                background
                spacing
              }
            }
            ... on PrismicPageDataBodySmallDetailCard {
              id
              slice_type
              primary {
                background
              }
              items {
                button_label
                card_hero_image {
                  alt
                  gatsbyImageData(layout: FULL_WIDTH)
                }
                card_logo {
                  url
                }
                card_title {
                  text
                }
                data_description
                data_point {
                  text
                }
                link {
                  url
                }
                theme
              }
            }
            ... on PrismicPageDataBodyMultiimagequote {
              id
              items {
                author
                author_meta
                quote {
                  richText
                }
                quote_image {
                  gatsbyImageData
                  alt
                  url
                }
                brand_logo {
                  gatsbyImageData
                  alt
                }
                layout
              }
              primary {
                background
                box_background
                spacing
                text_color
                theme
              }
              slice_type
            }
            ... on PrismicPageDataBodyQuoteSlider {
              id
              slice_type
              primary {
                background
                content {
                  richText
                }
                custom_code
                form
                label
                layout
                section_title {
                  text
                  richText
                }
                text
                spacing
                theme
              }
            }
            ... on PrismicPageDataBodyTimeline {
              id
              slice_type
              primary {
                background
                spacing
              }
              items {
                timeline_content {
                  richText
                }
                featured
              }
            }
            ... on PrismicPageDataBodyTimelineHeader {
              id
              slice_type
              items {
                quick_fact {
                  richText
                }
              }
              primary {
                header_content {
                  richText
                }
                section_content {
                  richText
                }
                section_title {
                  richText
                }
              }
            }
            ... on PrismicPageDataBodyMultiquote {
              id
              slice_type
              items {
                author
                author_meta
                quote {
                  richText
                }
              }
              primary {
                background
                spacing
                text_color
                theme
              }
            }
            ... on PrismicPageDataBodyContentWithSidebar {
              id
              primary {
                background
                content {
                  richText
                }
                content_html
                sidebar_html
                spacing
                theme
              }
              slice_type
            }
            ... on PrismicPageDataBodyIframe {
              id
              slice_type
              primary {
                source
              }
            }
            ... on PrismicPageDataBodyLegalContent {
              id
              slice_type
              primary {
                content {
                  richText
                }
                section_title {
                  richText
                }
              }
            }
            ... on PrismicPageDataBodyContentWithForm {
              id
              slice_type
              primary {
                background
                content {
                  richText
                }
                form_content {
                  richText
                }
                form_id
                form_title {
                  richText
                }
                html
                spacing
                theme
              }
            }
            ... on PrismicPageDataBodyForm {
              id
              slice_type
              primary {
                background
                form_content {
                  richText
                }
                form_id
                form_title {
                  richText
                }
                html
                spacing
                theme
              }
            }
            ... on PrismicPageDataBodyQuote {
              id
              slice_type
              primary {
                author
                author_meta
                background
                box_background
                quote {
                  richText
                }
                spacing
                theme
                text_color
              }
            }
            ... on PrismicPageDataBodyThreeColumnTable {
              id
              slice_type
              primary {
                comp_one{
                  richText
                }
                comp_one_theme
                comp_three{
                  richText
                }
                comp_three_theme
                comp_two{
                  richText
                }
                comp_two_theme
                section_content {
                  richText
                  text
                }
                section_title {
                  richText
                  text
                }
                theme
                spacing
              }
              items {
                feature_section {
                  document {
                    ... on PrismicCompetitorTable {
                      id
                      data {
                        content {
                          richText
                        }
                        features {
                          comp_one
                          comp_two
                          comp_three
                          feature
                          tooltip
                          tooltip_content {
                            text
                          }
                        }
                        theme
                        type_of_service
                      }
                    }
                  }
                }
              }
            }
            ... on PrismicPageDataBodyAccordion {
              id
              slice_type
              primary {
                background
                section_content {
                  richText
                }
                section_title {
                  richText
                }
                spacing
              }
              items {
                open
                content {
                  richText
                }
                content_title {
                  richText
                  text
                }
              }
            }
            ... on PrismicPageDataBodyCustom {
              id
              slice_type
              primary {
                code
              }
            }
            ... on PrismicPageDataBodyNavInsider {
              id
              slice_type
              primary {
                background
                spacing
                number_of_cards
              }
            }
            ... on PrismicPageDataBodyPartnerFooter {
              id
              slice_type
            }
            ... on PrismicPageDataBodyCcsCard {
              id
              slice_type
              items {
                partner_title
                categories
                program
                content {
                  richText
                }
                link {
                  url
                }
                partner_logo {
                  gatsbyImageData(layout: CONSTRAINED)
                }
              }
              primary {
                background
                spacing
              }
            }
            ... on PrismicPageDataBodyContentTabs {
              id
              slice_type
              items {
                tab_title {
                  richText
                }
                layout
                theme
                button_label
                button_link{
                  url
                }
                tab_label
                tab_label_icon {
                  url
                }
                tab_image {
                  gatsbyImageData(layout: CONSTRAINED)
                  alt
                }
                tab_content {
                  richText
                }
                supporting_content
                custom
              }
              primary {
                section_title {
                  richText
                }
                section_content {
                  richText
                }
                spacing
                background
              }
            }
            ... on PrismicPageDataBodyDataContent {
              id
              slice_type
              items {
                data_content {
                  richText
                }
                data_title
                icon {
                  alt
                  url
                }
                theme
              }
              primary {
                background
                columns
                layout
                section_title {
                  richText
                  text
                }
                section_content {
                  richText
                  text
                }
                spacing
              }
            }
            ... on PrismicPageDataBodyPeopleCard {
              id
              slice_type
              items {
                person {
                  url
                  document {
                    ... on PrismicPage {
                      id
                      data {
                        meta_image {
                          gatsbyImageData(layout: CONSTRAINED)
                          alt
                        }
                        body {
                          ... on PrismicPageDataBodyPeopleHeroBanner {
                            id
                            primary {
                              co_title
                              name {
                                text
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
              primary {
                spacing
                background
                entry_title{
                  richText
                  text
                }
              }
            }
            ... on PrismicPageDataBodyPeopleHeroBanner {
              id
              slice_type
              primary {
                name {
                  text
                }
                co_title
              }
            }
            ... on PrismicPageDataBodyRichContent {
              id
              slice_type
              items {
                button_color
                button_link {
                  url
                }
                label
              }
              primary {
                spacing
                theme
                content {
                  richText
                }
              }
            }
            ... on PrismicPageDataBodyHeroBanner {
              id
              slice_type
              items {
                button_color
                button_label
                button_link {
                  url
                  target
                }
              }
              primary {
                wave_color
                article_title {
                  richText
                  text
                }
                background
                content {
                  richText
                  text
                }
                hero_icon {
                  alt
                  url
                  dimensions {
                    height
                    width
                  }
                }
                video_id
                label
                shadow
                layout
                theme
              }
            }
            ... on PrismicPageDataBodyHeroBannerData {
              id
              slice_type
              items {
                data_text
                data_number
                data_theme
              }
              primary {
                wave_color
                article_title {
                  richText
                  text
                }
                background
                content {
                  richText
                  text
                }
                video_id
                label
                shadow
                theme
                button_color
                button_label
                button_link {
                  url
                  target
                }
              }
            }
            ... on PrismicPageDataBodyCard {
              id
              slice_type
              items {
                resource {
                  type
                  document {
                    ... on PrismicNavigationInsider {
                      url
                      id
                      type
                      data {
                        resource_title {
                          richText
                          text
                        }
                        resource_label
                        date_published(formatString: "MMMM DD, YYYY")
                        description {
                          text
                        }
                        meta_image {
                          gatsbyImageData(layout: CONSTRAINED)
                          alt
                        }
                      }
                    }
                    ... on PrismicPressRelease {
                      id
                      url
                      type
                      data {
                        resource_title {
                          richText
                          text
                        }
                        resource_label
                        date_published(formatString: "MMMM DD, YYYY")
                        description {
                          text
                        }
                        meta_image {
                          gatsbyImageData(layout: CONSTRAINED)
                          alt
                        }
                      }
                    }
                    ... on PrismicResource {
                      url
                      id
                      _previewable
                      data {
                        resource_type
                        resource_title {
                          richText
                          text
                        }
                        resource_label
                        description {
                          text
                        }
                        meta_image {
                          gatsbyImageData(layout: CONSTRAINED)
                          alt
                        }
                      }
                    }
                  }
                }
                button_label
                card_content_type
                card_label
                custom_content{
                  richText
                  text
                }
                resource_type
                custom_image {
                  gatsbyImageData(layout: CONSTRAINED)
                  alt
                  url
                }
                custom_title
                theme
                custom_link {
                  url
                  target
                }
              }
              primary {
                background
                card_layout
                spacing
                box
                box_background
                card_slider
                section_title {
                  richText
                  text
                }
                section_content {
                  richText
                  text
                }
              }
            }
            ... on PrismicPageDataBodySideBySide {
              id
              items {
                button_color
                button_label
                button_link {
                  url
                  target
                }
                link_type
              }
              slice_type
              primary {
                card_resource {
                  document {
                    ... on PrismicResource {
                      id
                      url
                      data {
                        resource_title {
                          richText
                          text
                        }
                        resource_label
                        meta_image {
                          gatsbyImageData(layout: CONSTRAINED)
                          alt
                        }
                        resource_type
                        description {
                          text
                        }
                      }
                    }
                    ... on PrismicNavigationInsider {
                      id
                      url
                      data {
                        resource_title {
                          richText
                          text
                        }
                        resource_label
                        meta_image {
                          gatsbyImageData(layout: CONSTRAINED)
                          alt
                        }
                        description {
                          text
                        }
                      }
                    }
                    ... on PrismicPressRelease {
                      id
                      url
                      data {
                        resource_title {
                          richText
                          text
                        }
                        resource_label
                        meta_image {
                          gatsbyImageData(layout: CONSTRAINED)
                          alt
                        }
                        description {
                          text
                        }
                      }
                    }
                  }
                }
                background
                background_image {
                  url
                }
                fade
                card_layout
                card_resource {
                  url
                }
                card_resource_button_label
                content {
                  text
                  richText
                }
                content_color
                custom_html
                custom_code
                css_classes
                icon {
                  alt
                  dimensions {
                    height
                    width
                  }
                  gatsbyImageData(layout: CONSTRAINED, placeholder: NONE)
                }
                image {
                  alt
                  gatsbyImageData(layout: CONSTRAINED, placeholder: NONE)
                }
                label
                layout
                alignment
                quote_author
                quote_author_title
                quote_content {
                  richText
                }
                support
                lottie_json
                video_animation {
                  url
                }
                video_animation_hvec{
                  url
                }
                box
                shadow
                box_background
                spacing
                theme
                title {
                  richText
                  text
                }
                video
              }
            }
            ... on PrismicPageDataBodyComparisonTable {
              id
              items {
                feature_section {
                  document {
                    ... on PrismicCompetitorTable {
                      id
                      _previewable
                      data {
                        features {
                          comp_one
                          comp_two
                          comp_three
                          feature
                          tooltip
                          tooltip_content {
                            text
                          }
                        }
                        type_of_service
                        content{
                          richText
                          text
                        }
                      }
                    }
                  }
                }
              }
              primary {
                section_title{
                  richText
                  text
                }
                comp_one {
                  richText
                }
                comp_one_button_label
                comp_one_button_link {
                  url
                }
                comp_one_theme
                comp_two {
                  richText
                }
                comp_two_button_label
                comp_two_button_link {
                  url
                }
                comp_two_theme
                type
                expand
                expanded_button_label
              }
              slice_type
            }
            ... on PrismicPageDataBodyTextBlock {
              id
              items {
                button_color
                button_link {
                  url
                  target
                }
                label
              }
              primary {
                background
                block_content {
                  richText
                }
                block_title {
                  richText
                  text
                }
                label
                icon{
                  url
                  alt
                }
                graphic{
                  gatsbyImageData
                  url
                  alt
                }
                box
                border
                box_background
                justify
                spacing
                theme
                width
              }
              slice_type
            }
          }
        }
        id
        url
    }
    prismicHeaderCallout {
      _previewable
      data {
        label {
          text
        }
        link {
          text
        }
        title {
          richText
        }
      }
    }
    prismicNavigation {
      _previewable
      id
      data {
        entry
        main_nav_items {
          nav_link {
            url
          }
          nav_label
          resource {
            document {
              ... on PrismicPressRelease {
                id
                data {
                  resource_label
                  resource_title {
                    text
                    richText
                  }
                  description {
                    text
                  }
                  meta_image {
                    gatsbyImageData
                    alt
                  }
                }
                url
              }
              ... on PrismicResource {
                id
                data {
                  resource_label
                  resource_title {
                    text
                    richText
                  }
                  description {
                    text
                  }
                  meta_image {
                    gatsbyImageData
                    alt
                  }
                }
                url
              }
            }
          }
          drop_down {
            id
            document {
              ... on PrismicNavigationItem {
                id
                data {
                  theme
                  sub_nav_item {
                    icon {
                      alt
                      gatsbyImageData(layout: CONSTRAINED)
                      url
                    }
                    nav_context{
                        text
                        richText
                      }
                    nav_label
                    sub_nav {
                      document {
                        ... on PrismicSubNavigationItem {
                          id
                          data {
                            sub_nav_item {
                              nav_label
                              nav_link {
                                url
                              }
                            }
                          }
                        }
                      }
                    }
                    nav_link {
                      url
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`


const Page = (props) => {


    return (
        <Layout headCall={props.data.prismicHeaderCallout.data} nav={props.data.prismicNavigation.data} footer={props.data.prismicPage.data.cta_footer}>
            <main className="page" id="main">
            <SliceZone slices={props.data.prismicPage.data.body} components={components} context={props.data.prismicPage} />
            </main>
        </Layout>
    )
}

export default Page

export const Head = (props) => {

  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://quantum-health.com" + props.data.prismicPage.url + '/'
    },
    "headline": props.data.prismicPage.data.title.text,
    "description": props.data.prismicPage.data.description.text,
    "image": props.data.prismicPage.data.meta_image.url,  
    "author": {
      "@type": "Organization",
      "name": "Quantum Health"
    }
  }

return <Seo hide={props.data.prismicPage.data.hide} title={(props.data.prismicPage.data.title.text) + ' - Quantum Health'} desc={props.data.prismicPage.data.description.text} metaImage={props.data.prismicPage.data.meta_image.url} url={props.data.prismicPage.url} schemaMarkup={schema} />}

